/**
 * Country Lane Line Item Properties Handler v3
 * 
 * Uses <button type="button"> elements — NOT radio inputs.
 * Updates hidden <input type="hidden"> fields that are linked to the
 * product form via the form="" attribute.
 * 
 * This script has ZERO interaction with Shopify's variant-picker.
 * It only manages:
 *   - Material button selection → updates hidden input
 *   - Stain Color swatch selection → updates hidden input
 *   - Material-based color filtering via <style> tag in <head>
 */
(function() {
  'use strict';

  var STYLE_ID = 'cl-material-filter';
  var CSS_VINYL = '.cl-swatch-item[data-color-type="vinyl"] { display: flex !important; } .cl-swatch-item[data-color-type="wood"] { display: none !important; }';
  var CSS_WOOD = ''; // static CSS already hides vinyl by default

  function getOrCreateStyleTag() {
    var tag = document.getElementById(STYLE_ID);
    if (!tag) {
      tag = document.createElement('style');
      tag.id = STYLE_ID;
      document.head.appendChild(tag);
    }
    return tag;
  }

  function setMaterialFilter(material) {
    var tag = getOrCreateStyleTag();
    tag.textContent = (material.toLowerCase() === 'vinyl') ? CSS_VINYL : CSS_WOOD;
  }

  function handleMaterialClick(btn) {
    var container = btn.closest('.cl-line-item-properties');
    if (!container) return;

    var material = btn.getAttribute('data-material');
    if (!material) return;

    // Update button styles
    container.querySelectorAll('.cl-material-pill').forEach(function(b) {
      b.classList.remove('cl-material-pill--selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('cl-material-pill--selected');
    btn.setAttribute('aria-pressed', 'true');

    // Update hidden input
    var hiddenInput = container.querySelector('.cl-hidden-material');
    if (hiddenInput) hiddenInput.value = material;

    // Update color filter
    setMaterialFilter(material);

    // Ensure a visible color is selected
    ensureVisibleColorSelected(container);
  }

  function handleSwatchClick(btn) {
    var container = btn.closest('.cl-line-item-properties');
    if (!container) return;

    var color = btn.getAttribute('data-color');
    if (!color) return;

    // Update swatch styles
    container.querySelectorAll('.cl-swatch-item').forEach(function(b) {
      b.classList.remove('cl-swatch-item--selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('cl-swatch-item--selected');
    btn.setAttribute('aria-pressed', 'true');

    // Update hidden input
    var hiddenInput = container.querySelector('.cl-hidden-stain-color');
    if (hiddenInput) hiddenInput.value = color;
  }

  function ensureVisibleColorSelected(container) {
    var materialBtn = container.querySelector('.cl-material-pill--selected');
    var material = materialBtn ? materialBtn.getAttribute('data-material') : 'Wood';
    var correctType = (material.toLowerCase() === 'vinyl') ? 'vinyl' : 'wood';

    // Check if current selection is valid
    var currentSelected = container.querySelector('.cl-swatch-item--selected');
    if (currentSelected && currentSelected.getAttribute('data-color-type') === correctType) {
      return; // Current selection is fine
    }

    // Select first swatch of the correct type
    var firstCorrect = container.querySelector('.cl-swatch-item[data-color-type="' + correctType + '"]');
    if (firstCorrect) {
      container.querySelectorAll('.cl-swatch-item').forEach(function(b) {
        b.classList.remove('cl-swatch-item--selected');
        b.setAttribute('aria-pressed', 'false');
      });
      firstCorrect.classList.add('cl-swatch-item--selected');
      firstCorrect.setAttribute('aria-pressed', 'true');

      // Update hidden input
      var hiddenInput = container.querySelector('.cl-hidden-stain-color');
      if (hiddenInput) hiddenInput.value = firstCorrect.getAttribute('data-color');
    }
  }

  // Single click listener — only handles our buttons
  document.addEventListener('click', function(e) {
    // Material button
    var materialBtn = e.target.closest('.cl-material-pill');
    if (materialBtn) {
      handleMaterialClick(materialBtn);
      return;
    }

    // Swatch button
    var swatchBtn = e.target.closest('.cl-swatch-item');
    if (swatchBtn) {
      handleSwatchClick(swatchBtn);
      return;
    }
  });

  // Initialize on page load
  function init() {
    var container = document.querySelector('.cl-line-item-properties');
    if (!container) return;

    // Set initial material filter
    var materialBtn = container.querySelector('.cl-material-pill--selected');
    var material = materialBtn ? materialBtn.getAttribute('data-material') : 'Wood';
    setMaterialFilter(material);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
